// extracted by css-extract-rspack-plugin
export default {"TablesDivider":"D5Z8Z","IconWrapper":"v8dse"};